import(/* webpackMode: "eager" */ "/root/workspace/bravve-independent-station-web_jyzf/src/app/global-error.tsx");
